/* eslint-disable @typescript-eslint/no-unused-vars */
import { RcFile } from 'antd/lib/upload';
import { ICreditLimits } from '../../store/ducks/credit-limits/types';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';
import { ELocalStorageKey, ILocalStorageObj } from '../EGerdauService/types';

interface ICreditLimitsService {
  readonly localStorageKey: ELocalStorageKey;
  getCreditLimits(customerId: string): Promise<ICreditLimits>;
  canReturnLocalStorageData(
    localStorageData: ILocalStorageObj,
    customerId: string
  ): boolean;
}

export class CreditLimitsService
  extends EGerdauService
  implements ICreditLimitsService
{
  readonly localStorageKey = ELocalStorageKey.CREDIT_LIMITS;

  async getCreditLimits(customerId: string): Promise<ICreditLimits> {
    // const localStorageData = this.getLocalStorage(this.localStorageKey);

    // if(localStorageData && this.canReturnLocalStorageData(localStorageData, customerId)){
    //     return localStorageData.obj as ICreditLimits;
    // }

    const headers = this.getHeaders();
    const creditLimitsResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CREDIT_LIMITS}/${customerId}`,
      { headers }
    );

    const creditLimits: ICreditLimits = creditLimitsResponse.data.creditLimits;

    const getOpenPortifolioUsed = (creditLimits: ICreditLimits) => {
      creditLimits.openPortifolioUsedCredit = (
        Number(creditLimits.shippingUsedCredit) +
        Number(creditLimits.openOrdersUsedCredit)
      ).toString();
      creditLimits.openPortifolioUsedCreditPercentage = (
        Number(creditLimits.shippingUsedCreditPercentage) +
        Number(creditLimits.openOrdersUsedCreditPercentage)
      ).toString();
    };

    getOpenPortifolioUsed(creditLimits);
    creditLimits.subsidiaries.forEach((subsidary) =>
      getOpenPortifolioUsed(subsidary)
    );

    creditLimits.parentOpenPortifolioCredit = (
      Number(creditLimits.total.openOrdersUsedCredit) +
      Number(creditLimits.total.shippingUsedCredit)
    ).toString();
    creditLimits.parentOpenPortifolioCreditPercentage = (
      Number(creditLimits.total.openOrdersUsedCreditPercentage) +
      Number(creditLimits.total.shippingUsedCreditPercentage)
    ).toString();

    // this.setLocalStorage(this.localStorageKey, creditLimits, customerId);

    return creditLimits;
  }

  async requestRenewCreditLimits(
    customerId: string,
    renewCreditValue: number,
    _files: RcFile[]
  ): Promise<{ creditRenewCode: string; creditRenewRequestId: string }> {
    const headers = this.getHeaders();
    const renewCreditLimitsResponse = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.RENEW_CREDIT_LIMITS}`,
      {
        customerId,
        value: `${renewCreditValue.toString()}.00`
      },
      { headers }
    );

    return {
      creditRenewCode: renewCreditLimitsResponse.data.chamado,
      creditRenewRequestId: renewCreditLimitsResponse.data['request-id']
    };
  }

  private async getBase64FromFile(file: RcFile): Promise<string> {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        const dataUrl = reader.result as string;
        const base64 = dataUrl.split(',')[1];
        resolve(base64);
      };
    });
  }

  async uploadCreditLimitDocs(customerId: string, files: RcFile[]) {
    const headers = this.getHeaders();
    const filesRequests = await files.map(async (file, idx) => {
      const fileBase64 = await this.getBase64FromFile(file);
      return customersAuthorizationApi.post(
        `${ECustomerAuthorizationEndpoints.RENEW_CREDIT_LIMITS_DOCS}`,
        {
          customerId: customerId,
          file: fileBase64,
          fileName: file.name.split(' ').join(''),
          number: idx
        },
        { headers }
      );
    });

    await Promise.all(filesRequests);
  }

  canReturnLocalStorageData(
    localStorageData: ILocalStorageObj,
    customerId: string
  ): boolean {
    const now = new Date();

    return (
      now.getTime() - localStorageData.dateTime <= 3600000 && // 1h
      customerId === localStorageData.customerId
    );
  }
}
